import { CurrencyCode, CURRENCY_CODE_TO_DECIMALS_MAP } from '@schuettflix/utils';

import { Money } from 'bigint-money';

export class Price {
    value: Money;

    constructor(value: number | string | undefined, currency: CurrencyCode) {
        const cleanedUpValue = `${value}`.replace(',', '.');
        this.value = new Money(value === undefined ? 0 : cleanedUpValue, currency);
    }

    public toString(): string {
        return this.value.toFixed(CURRENCY_CODE_TO_DECIMALS_MAP[this.value.currency as CurrencyCode]);
    }

    public toNumber(): number {
        return parseFloat(this.value.format());
    }

    public add(price: Price): Price {
        return new Price(this.value.add(price.value).format(), this.value.currency as CurrencyCode);
    }

    public subtract(price: Price): Price {
        return new Price(this.value.subtract(price.value).format(), this.value.currency as CurrencyCode);
    }

    public multiply(factor: number): Price {
        return new Price(this.value.multiply(`${factor}`).format(), this.value.currency as CurrencyCode);
    }

    public divide(divisor: string | number | Price): Price {
        if (divisor instanceof Price) {
            return new Price(this.value.divide(divisor.value).format(), this.value.currency as CurrencyCode);
        }
        return new Price(this.value.divide(`${divisor}`).format(), this.value.currency as CurrencyCode);
    }
}
